export function calculateState(): string {
    return ""
}

